module.exports = __webpack_public_path__ + "fork.svg?89d600db395727a591db86687833650b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/fork.svg
// module id = 164
// module chunks = 0